(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', '../../styles', './PaginationItem'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('../../styles'), require('./PaginationItem'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.styles, global.PaginationItem);
    global.Pagination = mod.exports;
  }
})(this, function (exports, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _styles, _PaginationItem) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  var _PaginationItem2 = _interopRequireDefault(_PaginationItem);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Pagination = function (_Component) {
    (0, _inherits3.default)(Pagination, _Component);

    function Pagination() {
      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, Pagination);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handlePageChange = function (e) {
        var isClick = e.type === 'click';
        var isKey = e.type === 'keypress';
        // TODO: Use idx for path checking
        var keyPressed = e.key || null;
        var isEnterKeyPress = isKey && keyPressed === 'Enter';

        if (isClick || isEnterKeyPress) {
          var _activePageNumber = parseInt(e.currentTarget.dataset.value, 10);

          _this.props.onPageChange(_activePageNumber);
        }
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Pagination.prototype.render = function render() {
      var _this2 = this;

      var _props = this.props,
          color = _props.color,
          pagesPerSet = _props.pagesPerSet,
          testId = _props.testId;
      var _props2 = this.props,
          activePageNumber = _props2.activePageNumber,
          pageCount = _props2.pageCount;


      if (pageCount < 1) pageCount = 1;
      if (activePageNumber < 1) activePageNumber = 1;

      // Number of page sets
      var pageSetCount = Math.ceil(pageCount / pagesPerSet);
      // Index of active page set (1-based)
      var activePageSetIndex = Math.ceil(activePageNumber / pagesPerSet);
      // Lowest page number in active page set
      var activePageSetMin = pagesPerSet * (activePageSetIndex - 1) + 1;
      // Greatest page number in active page set
      var activePageSetMax = pagesPerSet * activePageSetIndex;
      var prevPageNumber = Math.max(activePageNumber - 1, 1);
      var nextPageNumber = Math.min(activePageNumber + 1, pageCount);

      // Cheeky Bools down by the billabong
      var isFirstPageActive = activePageNumber === 1;
      var isLastPageActive = activePageNumber === pageCount;
      var isFirstPageSetActive = activePageSetIndex === 1;
      var isLastPageSetActive = activePageSetIndex === pageSetCount;
      var isMoreThanOnePageSet = pageSetCount !== 1;
      var isMoreThanOnePage = pageCount > 1;

      var middlePages = Array(pagesPerSet).fill().reduce(function (accum, next, ind) {
        var pageNumber = activePageSetMin + ind;
        var isActivePage = pageNumber === activePageNumber;

        if (pageNumber < pageCount && pageNumber !== 1) {
          return [].concat(accum, [{ pageNumber: pageNumber, isActivePage: isActivePage }]);
        }

        return accum;
      }, []);

      return _react2.default.createElement(
        'nav',
        { 'aria-label': 'Pagination Navigation', 'data-testid': testId, style: { display: 'flex', flexDirection: 'row' } },
        _react2.default.createElement(_PaginationItem2.default, {
          color: color,
          icon: 'chevron_left',
          pageNumber: prevPageNumber,
          handlePageChange: this.handlePageChange,
          disabled: isFirstPageActive,
          testId: testId + '-prev'
        }),
        _react2.default.createElement(_PaginationItem2.default, {
          color: color,
          pageNumber: 1,
          active: isFirstPageActive,
          handlePageChange: this.handlePageChange,
          testId: testId + '-1'
        }),
        !isFirstPageSetActive && isMoreThanOnePageSet && _react2.default.createElement(_PaginationItem2.default, {
          color: color,
          icon: 'more_horiz',
          pageNumber: activePageSetMin - 1,
          handlePageChange: this.handlePageChange,
          testId: testId + '-prev-set'
        }),
        middlePages.map(function (_ref) {
          var pageNumber = _ref.pageNumber,
              isActivePage = _ref.isActivePage;
          return _react2.default.createElement(_PaginationItem2.default, {
            color: color,
            key: pageNumber,
            pageNumber: pageNumber,
            active: isActivePage,
            handlePageChange: _this2.handlePageChange,
            testId: testId + '-' + pageNumber
          });
        }),
        !isLastPageSetActive && isMoreThanOnePageSet && _react2.default.createElement(_PaginationItem2.default, {
          color: color,
          icon: 'more_horiz',
          pageNumber: activePageSetMax + 1,
          handlePageChange: this.handlePageChange,
          testId: testId + '-next-set'
        }),
        isMoreThanOnePage && _react2.default.createElement(_PaginationItem2.default, {
          color: color,
          pageNumber: pageCount,
          active: isLastPageActive,
          handlePageChange: this.handlePageChange,
          testId: testId + '-' + pageCount
        }),
        _react2.default.createElement(_PaginationItem2.default, {
          color: color,
          icon: 'chevron_right',
          pageNumber: nextPageNumber,
          handlePageChange: this.handlePageChange,
          disabled: isLastPageActive,
          testId: testId + '-next'
        })
      );
    };

    return Pagination;
  }(_react.Component);

  Pagination.defaultProps = {
    color: _styles.colors.jungle,
    pagesPerSet: 3
  };
  exports.default = Pagination;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Pagination/Pagination.js
// module id = 1186
// module chunks = 0